import React, { Component, act } from 'react'
import { Container, Tab, Tabs, Modal, Button, Row, Col, Card, Alert } from 'react-bootstrap';
import { Navigate } from "react-router-dom";
import Assets from '../components/assets'
import Categories from '../components/category'
import Transactions from '../components/transactions'
import {connect} from 'react-redux';
import {getUser, getBook, getTransactions, getAssets, getCategories, getAssetsHistory, getCategoriesHistory} from 'context/actions/index';
import DatePicker from "react-datepicker";
import { 
    FaBookmark,
    FaWallet,
    FaChartPie,
    FaExchangeAlt,
    FaUserCircle
} from 'react-icons/fa';
import "react-datepicker/dist/react-datepicker.css";
import 'assets/Home.css';

class Home extends Component {
    constructor(props){
        super(props);
        this.state ={
            bookName: '',
            key:"Transaction",
            firstTime:false,
            fTDesc:false,
            user_id:"",
            name:"",
            phone:"",
            dob:"",
            profession:"",
            sex:"",
            location:"",
            marriage:"",
            smoking:"",
            bio:"",
            month:"",
            startDate: new Date(),
            loading: true,
            error: null,
            showWelcome: true,
            active_month: new Date()
        }
    }

    componentDidMount(){
        this.initializeUserData();
    }


    initializeUserData = async () => {
        try {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            
            let data = JSON.parse(localStorage['user-data']);
            let user = await this.props.getUser(data.user_id);
            
            if(user === "new"){
                this.setState({redirect: true, needUpdate:"/user", loading: false})
                return;
            }
            
            const userData = user.data[0];
            this.setState({
                user_id: userData.ID,
                name: userData.name,
                phone: userData.phone,
                dob: new Date(userData.dob),
                profession: userData.profession,
                sex: userData.sex,
                location: userData.location,
                marriage: userData.marriage,
                smoking: userData.smoking,
                bio: userData.bio,
                loading: false
            });

            // Check if user profile is complete
            const requiredFields = ['name', 'phone', 'dob', 'profession', 'sex', 'location'];
            const isProfileComplete = requiredFields.every(field => 
                userData[field] && userData[field] !== ""
            );

            if(!isProfileComplete){
                this.setState({redirect: true, needUpdate:"/user"})
                return;
            }

            if(!userData.default_book_id){
                this.setState({redirect: true, needUpdate:"/books"})
                return;
            }

            // Set book ID and get book data
            localStorage.setItem("bookId", userData.default_book_id);
            const book = await this.props.getBook(userData.default_book_id);
            
            const active_month = new Date(book.data[0].active_month);
            this.setState({active_month:active_month, startDate:active_month})
            const today = new Date();
            
            if(today.getUTCMonth() !== active_month.getUTCMonth() || 
               today.getUTCFullYear() !== active_month.getUTCFullYear()){
                
                if(window.confirm(`Bulan aktif buku adalah ${monthNames[active_month.getUTCMonth()]} ${active_month.getUTCFullYear()}, ganti dengan bulan sekarang?`)){
                    this.setState({redirect: true, needUpdate:"/reviewbook"})
                    return;
                }
            }

            await this.checkAllEssentials();

        } catch (error) {
            console.error("Error initializing user data:", error);
            this.setState({ error: "Gagal memuat data", loading: false });
        }
    }

    monthPicker = (props) => {
        return(
            <div className="month-picker-container">
                <DatePicker
                    selected={this.state.startDate}
                    onChange={this.changeTransactionMonth}
                    dateFormat="MMM yyyy"
                    showMonthYearPicker
                    className="form-control date-picker"
                    maxDate={this.state.active_month}
                />
            </div>
        )
    }

    handleClose = () => {
        this.setState({firstTime: false, submitted: false});
    }

    handleWelcomeClose = () => {
        this.setState({showWelcome: false});
    }

    tabSelect = (key) => {
        this.checkAllEssentials();
        this.setState({key: key});
        //this.setState({startDate: new Date()});
    }

    checkAllEssentials = async () => {
        try {
            //const d = new Date();
            const d = this.state.active_month
            const bookId = JSON.parse(localStorage.bookId);

            
            
            const assets = await this.props.getAssets(bookId);
            if(assets.length === 0){
                this.setState({
                    key: "Balance", 
                    firstTime: true, 
                    fTDesc: "Untuk memulai, Anda perlu menambahkan minimal 1 ASSET LANCAR terlebih dahulu."
                });
                return;
            }

           

            const categories = await this.props.getCategories(bookId);
            if(categories.length === 0){
                this.setState({
                    key: "Category", 
                    firstTime: true, 
                    fTDesc: "Anda perlu menambahkan minimal 1 CATEGORY untuk pemasukan dan pengeluaran."
                });
                return;
            }
            this.changeTransactionMonth(d)
            //await this.props.getTransactions(bookId, d.getMonth() + 1, d.getFullYear());

            
            
        } catch (error) {
            console.error("Error checking essentials:", error);
        }
    }

    changeTransactionMonth = (date) => {
        this.setState({startDate: date});
        const bookId = JSON.parse(localStorage.bookId);
        const active_month = new Date(this.props.books.active_month);
        
        this.props.getTransactions(bookId, date.getMonth() + 1, date.getFullYear());
        
        if((date.getMonth() + 1) !== active_month.getMonth() + 1){
            this.props.getAssetsHistory(bookId, date.getMonth() + 1, date.getFullYear());
            //this.props.getCategoriesHistory(bookId, date.getMonth() + 1, date.getFullYear());
        } else {
            this.props.getAssets(this.props.books.book_id);
            this.props.getCategories(this.props.books.book_id);
        }
    }

    renderWelcomeMessage = () => {
        if (!this.state.showWelcome) return null;

        return (
            <Alert variant="info" dismissible onClose={this.handleWelcomeClose} className="welcome-alert">
                <FaUserCircle size={20} className="me-2" />
                <strong>Selamat datang, {this.state.name}!</strong> Mulai kelola keuangan Anda dengan mudah.
            </Alert>
        );
    }

    render() {
        if(this.state.redirect){
            return <Navigate to={this.state.needUpdate} />
        }

        if(this.state.loading){
            return (
                <Container className="py-5 text-center">
                    <div className="loading-spinner">Memuat data...</div>
                </Container>
            );
        }

        if(this.state.error){
            return (
                <Container className="py-5">
                    <Alert variant="danger">
                        {this.state.error}
                    </Alert>
                </Container>
            );
        }

        return (
            <React.Fragment>
                <Modal
                    show={this.state.firstTime}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <FaBookmark className="text-primary me-2" />
                            Panduan Pemula
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{this.state.fTDesc}</p>
                        <small className="text-muted">
                            Ikuti panduan ini untuk memulai penggunaan aplikasi dengan benar.
                        </small>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleClose}>
                            Mengerti
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Container className='py-4 home-container'>
                    {this.renderWelcomeMessage()}
                    
                    <Card className="mb-4 header-card">
                        <Card.Body>
                            <Row className="align-items-center">
                                <Col md={6}>
                                    <div className="d-flex align-items-center">
                                        <FaBookmark className="text-primary me-3" size={35} />
                                        <div>
                                            <h2 className="mb-1">{this.props.books.name || "Buku Keuangan"}</h2>
                                            <p className="text-muted mb-0">Selamat datang di dashboard keuangan Anda</p>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6} className="text-md-end">
                                    <div className="date-picker-wrapper">
                                        <label className="form-label me-2">Pilih Bulan:</label>
                                        <this.monthPicker />
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Tabs
                        id="main-tab"
                        className="mb-3 custom-tabs"
                        activeKey={this.state.key}
                        onSelect={this.tabSelect}
                        justify
                    >
                        <Tab 
                            eventKey="Transaction" 
                            title={
                                <span>
                                    <FaExchangeAlt className="me-2" />
                                    Transaksi
                                </span>
                            }
                        >
                            <Transactions />
                        </Tab>
                        <Tab 
                            eventKey="Balance" 
                            title={
                                <span>
                                    <FaWallet className="me-2" />
                                    Akun
                                </span>
                            }
                        >
                            <Assets />
                        </Tab>
                        <Tab 
                            eventKey="Category" 
                            title={
                                <span>
                                    <FaChartPie className="me-2" />
                                    Kategori
                                </span>
                            }
                        >
                            <Categories />    
                        </Tab>
                    </Tabs>
                </Container>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return{
        user: state.user,
        books: state.books,
        assets: state.assets,
        categories: state.categories
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getUser: (user) => dispatch(getUser(user)),
        getBook: (book) => dispatch(getBook(book)),
        getTransactions: (book, month, year) => dispatch(getTransactions(book, month, year)),
        getAssets: (book) => dispatch(getAssets(book)),
        getAssetsHistory: (book, month, year) => dispatch(getAssetsHistory(book, month, year)),
        getCategories: (book) => dispatch(getCategories(book)),
        getCategoriesHistory: (book, month, year) => dispatch(getCategoriesHistory(book, month, year)),
    }
} 

export default connect(mapStateToProps, mapDispatchToProps)(Home);